import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children }) => (
  <span className="inline-flex items-center gap-2 rounded-full bg-[#1677FF]/8 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.15em] text-[#1677FF]">
    <span className="h-1.5 w-1.5 rounded-full bg-[#22C7D6]" />
    {children}
  </span>
);
